<section id="kontakt" class="wl-section contact">
  <div class="wl-inner inner">
    <app-section-heading
      eyebrow="Kontakt"
      title="Porozmawiajmy o Waszym weselu"
      subtitle="Masz pytanie o grę albo ofertę dla DJ-a? Odpisujemy zwykle tego samego dnia." />

    <div class="stack">
      <div class="form-card">
        <app-contact-form inputBg="#fff" />
      </div>

      <button (click)="copyEmail()" class="email-card">
        <div class="email-icon">
          @if (copied()) {
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#B08947" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
          } @else {
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#B08947" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"></rect><path d="m22 7-10 5L2 7"></path></svg>
          }
        </div>
        <div class="email-text">
          <p class="email-label">Napisz do nas bezpośrednio</p>
          <span class="email-addr">kontakt@weselelive.pl</span>
        </div>
        <span class="email-hint">
          {{ copied() ? 'Skopiowano!' : 'Kliknij, by skopiować' }}
        </span>
      </button>
    </div>
  </div>
</section>
